import {initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import makeSlice from '@web/slices/receivableReward/sliceMaker'

const receivableRewardSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {data}}) => {
            state.rewardedItems = data.confirmedProductOrders
            state.isFamilyPay = data.familyPay
        })
    },
})

export default receivableRewardSlice.reducer
